/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const KeyRound = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M2 18v3c0 .6.4 1 1 1h4v-3h3v-3h2l1.4-1.4a6.5 6.5 0 1 0-4-4Z" }],
    ["circle", { cx: "16.5", cy: "7.5", r: ".5" }]
  ]
];

export { KeyRound as default };
//# sourceMappingURL=key-round.js.map
